export const DECORATIVE_COLORS = [
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "purple",
  "pink",
] as const;

export type DecorativeColors = (typeof DECORATIVE_COLORS)[number];

export const getDecorativeColorToken = (
  type: "background" | "border" | "content",
  color: DecorativeColors | "neutral",
  hierarchy?:
    | "base-bold"
    | "base-subtle"
    | "base-bolder"
    | "hover-subtle"
    | "hover-bolder",
) => {
  switch (type) {
    case "background":
      return `background.decorative.${color}.${hierarchy}`;
    case "border":
      return `border.decorative.${color}`;
    case "content":
      return `content.decorative.${color}`;
  }
};
